import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { compose } from 'redux'
import { withStyles } from '@material-ui/core'

import { RoutesTabsBase } from './RoutesTabs'

import {
  routesSelector,
  routeIdSelector,
  isLoadingSelector,
  fromUaRoutesSelector
} from 'reduxModules/selectors/RouteSelectors'
import { isPricesPageSelector, isRoutesPageSelector } from 'reduxModules/selectors/RouterSelectors'
import { companySelector } from 'reduxModules/selectors/UserSelectors'
import { routeActions } from 'reduxModules/actions/RouteActions'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  routes: routesSelector,
  routeId: routeIdSelector,
  company: companySelector,
  isLoading: isLoadingSelector,
  fromUaRoutes: fromUaRoutesSelector,
  isPricesPage: isPricesPageSelector,
  isRoutesPage: isRoutesPageSelector,
})

const mapDispatchToProps = {
  selectRoute: routeActions.selectRoute
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)

export const RoutesTabs = enhance(RoutesTabsBase)



// WEBPACK FOOTER //
// ./src/components/RoutesTabs/index.js